import React from 'react'

export default function Header() {
    return (
        <div id= 'main'>
            <div className='header-heading'>                          
            </div>

        </div>
    )
}
